import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable, InjectionToken } from '@angular/core';
import { Page, PageMetadata } from '@tran-monorepo/interfaces';
import { Location } from '@tran-monorepo/interfaces/applications';
import { Observable } from 'rxjs';

export const LOCATIONS_API_URL = new InjectionToken<string>('LOCATIONS_API_URL');

@Injectable({ providedIn: 'root' })
export class LocationService {
    private readonly http = inject(HttpClient);
    private readonly apiUrl = inject(LOCATIONS_API_URL);

    public getLocations(page = 0, pageSize = 20): Observable<Page<Location, PageMetadata>> {
        const params = new HttpParams({ fromObject: { page, pageSize } });

        return this.http.get<Page<Location, PageMetadata>>(this.apiUrl, {
            params
        });
    }
}
